import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';

const getSettlementList = (params = {}): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Settlement_List,
          payload: { ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data: any) => ({
      items: data.rows,
      totalRows: Infinity,
    }));
};

const addSettlement = (data) => {
  return new RpcService().request({
    messages: [{ type: RpcTypes.Settlement_Create, payload: { ...data } }],
    showValidateNotification: false,
  });
};

const confirmAddSettlement = (messageId, payload) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Settlement_CreateConfirmed,
        payload,
        id: messageId,
      },
    ],
    showValidateNotification: false,
  });
};

const confirmUpdateSettlement = (messageId, payload) => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Settlement_UpdateConfirmed,
        payload,
        id: messageId,
      },
    ],
    showValidateNotification: false,
  });
};

const updateSettlement = (data) => {
  return new RpcService().request({
    messages: [{ type: RpcTypes.Settlement_Update, payload: { ...data } }],
    showValidateNotification: false,
  });
};

const deleteSettlement = (id) => {
  return new RpcService().request({
    messages: [{ type: RpcTypes.Settlement_Delete, payload: { id } }],
  });
};

export {
  getSettlementList,
  addSettlement,
  confirmAddSettlement,
  confirmUpdateSettlement,
  updateSettlement,
  deleteSettlement,
};
